// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
export const stringPurify = (str) => {
  if (typeof str === "string") {
    return str.replace(/(<([^>]+)>)/gi, "");
  } else return "";
};

export const getExtension = (str) =>
  typeof str === "string" && str.split(".").pop();
